import { InputType } from "../Input";

/** Typ podporovaných typů editačního pole. */
export type EditComponentInputType = InputType.text | InputType.password;
